// @flow
import { createContext } from 'react';
import type { Context } from 'react';

type CartContextType = {
  toggleMiniCart: Function,
  updateCart: Function,
  showMiniCart: boolean,
  cart: Object,
};

export const CartContext: Context<CartContextType> = createContext({
  toggleMiniCart: () => {},
  updateCart: () => {},
  showMiniCart: false,
  cart: {},
});
